module.exports = __webpack_public_path__ + "img/sp-1.a277c985.png";